import { render, staticRenderFns } from "./acciones.vue?vue&type=template&id=1bba3dc2&"
import script from "./acciones.vue?vue&type=script&lang=js&"
export * from "./acciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports